import { CircularProgress } from '@mui/material';
import { CheckmarkAcceptableBadgeSvg } from 'apps/sigma2-ui/src/components/svg/CheckmarkAcceptableBadge';
import React from 'react';

export type SaveIndicatorStatus = 'saving' | 'saved' | 'idle';

export const SaveIndicator = ({ status }: { status: SaveIndicatorStatus }) => {
  return status === 'saving' ? (
    <CircularProgress className="text-secondary" size={32} thickness={8} />
  ) : status === 'saved' ? (
    <>
      <CheckmarkAcceptableBadgeSvg
        svg={{ className: 'text-green-600 w-5 h-5' }}
        wantsCurrentColor
      />
    </>
  ) : null;
};
